export function useRotateAndScale(dom, cfg = { time: 0.5, timingFunction: 'ease-in-out', color: '#ff5e2a', rotate: 5 }) {
  if (!dom) {
    console.warn('useRotateAndScale 未找到 dom。')
    return () => {}
  }
  let time = cfg.time || 0.5
  let timingFunction = cfg.timingFunction || 'ease-in-out'

  if (!document.getElementById('rotate-and-scale-id')) {
    const style = document.createElement('style')
    style.id = 'rotate-and-scale-id'
    style.textContent = `
          @keyframes rotate-and-scale-keyframes {
              0% {
                  transform: rotate(0deg) scale(1.2);
                  color: ${cfg.color}ff;
              }
              11.11% {
                  transform: rotate(${cfg.rotate * 3}deg) scale(0.9);
                  color: ${cfg.color}3f;
              }
              22.22% {
                  transform: rotate(-${cfg.rotate * 3}deg) scale(0.8);
                  color: ${cfg.color}6f;
              }
              33.33% {
                  transform: rotate(0deg) scale(0.9);
                  color: ${cfg.color}9f;
              }
              44.44% {
                  transform: rotate(${cfg.rotate * 2}deg) scale(1);
                  color: ${cfg.color}ff;
              }
              55.55% {
                  transform: rotate(-${cfg.rotate * 2}deg) scale(1.1);
                  color: ${cfg.color}3f;
              }*/
              66.66% {
                  transform: rotate(0deg) scale(1.2);
                  color: ${cfg.color}6f;
              }
              77.77% {
                  transform: rotate(${cfg.rotate}deg) scale(1);
                  color: ${cfg.color}9f;
              }
              88.88% {
                  transform: rotate(-${cfg.rotate}deg) scale(0.9);
                  color: ${cfg.color}ff;
              }
              100% {
                  transform: rotate(0deg) scale(1);
              }
          }
      `
    document.head.appendChild(style)
  }

  let isAnimating = false // 动画进行中标志
  let debounceTimeout = null // 防抖定时器

  return function () {
    if (isAnimating) return
    isAnimating = true
    dom.style.animation = 'none'
    // 这行不能删除，用于触发浏览器 reflow 确保动画可以重新开始
    void dom.offsetWidth
    dom.style.animation = `rotate-and-scale-keyframes ${time}s ${timingFunction} forwards`
    if (debounceTimeout) clearTimeout(debounceTimeout)
    debounceTimeout = setTimeout(() => {
      isAnimating = false
      dom.style.animation = ''
    }, 550)
  }
}

// 使用示例：
// const animation = useRotateAndScale('.someClass');
// animation(); // 每次调用都会触发一次动画（如果未在进行中）

